import React from "react";

import { MenuItem } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import IOption from "common/models/IOption";
import { IWidgetProps } from "decorator-form";
import { DropdownSelectVariant, ofType } from "./DropdownSelect.view";



/**
 * @description wrapper for {@link DropdownSelectView} that uses {@link IOption} as the value type.
 * for use in forms mostly probably?
 * @author chills
 */


const OptionSelect = ofType<IOption<string>>();


interface IOptionDropdownSelectProps extends IWidgetProps<string> {
	options: Array<IOption<string>>;
	variant?: DropdownSelectVariant;
	viewKey: string;
}

export const OptionDropdownSelect: React.SFC<IOptionDropdownSelectProps> = ({children, label, onChange, options, value, variant = DropdownSelectVariant.MINIMAL, viewKey}) => {

	const selectedOption: IOption<string> | undefined = value ? options.find((option) => option.value === value) : undefined;

	return (
		<OptionSelect
			label={label}
			items={options}
			itemRenderer={(option, { handleSelect }) => (
				<MenuItem
					key={option.value}
					icon={option.value === value ? IconNames.SMALL_TICK : undefined}
					onClick={handleSelect}
					text={option.label}
				/>
			)}
			onChange={(option) => onChange(option.value)}
			variant={variant}
			viewKey={viewKey}
		>
			{children || label}
			{selectedOption && [': ', <span style={{fontWeight: "bold"}}>&nbsp;{selectedOption.label}</span>]}
		</OptionSelect>
	);
};



// WEBPACK FOOTER //
// ./src/common/views/dropdownSelect/OptionDropdownSelect.tsx